import { clientFetch } from "@/utils/service";
import {
  FETCH_CONSULTATIONS,
  FETCH_CONSULTATION,
  UPDATE_CONSULTATION,
  CREATE_CONSULTATION,
  CANCEL_CONSULTATION,
  COMPLETE_CONSULTATION,
  FETCH_AGORA_CONSULTATION,
} from './consultationsActionsTypes';
import { isFunction, qsToObj } from "@/utils/helpers";
import { toast } from "react-toastify";

const basePath = '/admin/consultations';
export const fetchConsultations = (qs) => {
  const query = !!qs ? qsToObj(qs) : {};
  return {
    type: FETCH_CONSULTATIONS,
    payload: clientFetch(basePath, { query }),
  };
};

export const fetchConsultation = (id) => {
  return {
    type: FETCH_CONSULTATION,
    payload: clientFetch(`/admin/consultations/${id}`),
  };
};

export const submitConsultation = async ({
  id,
  data = {},
  fromSheduleId,
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
  };
  const path = !!id ? `${basePath}/${id}` : basePath;
  const type = !!id ? UPDATE_CONSULTATION : CREATE_CONSULTATION;
  const method = !!id ? 'PATCH' : 'POST';

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: {...res, fromSheduleId, fromId: id },
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const cancelConsultation = (id, { onSuccess, t, scheduleId }) => {
  return {
    type: CANCEL_CONSULTATION,
    payload: clientFetch(`${basePath}/${id}/cancel`)
      .then((res) => {
        toast.success(t('consultation.cancel_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id, scheduleId };
      })
      .catch((err) => {
        toast.error(t('consultation.cancel_error'));
      }),
  };
};

export const completeConsultation = (id, { onSuccess, t, scheduleId }) => {
  return {
    type: COMPLETE_CONSULTATION,
    payload: clientFetch(`${basePath}/${id}/complete`)
      .then((res) => {
        toast.success(t('consultation.complete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id, scheduleId };
      })
      .catch((err) => {
        toast.error(t('consultation.complete_error'));
        console.log('err', err);
      }),
  };
};

export const fetchAgoraConsultation = (id) => {
  return {
    type: FETCH_AGORA_CONSULTATION,
    payload: clientFetch(`/admin/consultations/${id}`),
  };
};